
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93ILszah2VNpMeta } from "/app/pages/[...slug].vue?macro=true";
import { default as addressOWzGt9wlBZMeta } from "/app/pages/account/address.vue?macro=true";
import { default as indexQWKFaMHH2OMeta } from "/app/pages/account/index.vue?macro=true";
import { default as orderMBG0Sh5etWMeta } from "/app/pages/account/order.vue?macro=true";
import { default as paymentI6FeC2iYYyMeta } from "/app/pages/account/payment.vue?macro=true";
import { default as profilelwi6rEuniiMeta } from "/app/pages/account/profile.vue?macro=true";
import { default as passwordv4QIVRuQi3Meta } from "/app/pages/account/recover/password.vue?macro=true";
import { default as wishlistzQE62vNi5oMeta } from "/app/pages/account/wishlist.vue?macro=true";
import { default as cart9SktLKPpbzMeta } from "/app/pages/cart.vue?macro=true";
import { default as indexKZUQ8EqxmNMeta } from "/app/pages/checkout/[id]/index.vue?macro=true";
import { default as paidCexgTvKlRqMeta } from "/app/pages/checkout/[id]/paid.vue?macro=true";
import { default as unpaid9xNbere4xkMeta } from "/app/pages/checkout/[id]/unpaid.vue?macro=true";
import { default as index7ZtduOIoVXMeta } from "/app/pages/checkout/index.vue?macro=true";
import { default as searchfcnTL5fl5XMeta } from "/app/pages/search.vue?macro=true";
export default [
  {
    name: "slug___lt-LT",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___en-GB",
    path: "/en-GB/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "account-address___lt-LT",
    path: "/account/address",
    meta: addressOWzGt9wlBZMeta || {},
    component: () => import("/app/pages/account/address.vue")
  },
  {
    name: "account-address___en-GB",
    path: "/en-GB/account/address",
    meta: addressOWzGt9wlBZMeta || {},
    component: () => import("/app/pages/account/address.vue")
  },
  {
    name: "account___lt-LT",
    path: "/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account___en-GB",
    path: "/en-GB/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-order___lt-LT",
    path: "/account/order",
    meta: orderMBG0Sh5etWMeta || {},
    component: () => import("/app/pages/account/order.vue")
  },
  {
    name: "account-order___en-GB",
    path: "/en-GB/account/order",
    meta: orderMBG0Sh5etWMeta || {},
    component: () => import("/app/pages/account/order.vue")
  },
  {
    name: "account-payment___lt-LT",
    path: "/account/payment",
    meta: paymentI6FeC2iYYyMeta || {},
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payment___en-GB",
    path: "/en-GB/account/payment",
    meta: paymentI6FeC2iYYyMeta || {},
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-profile___lt-LT",
    path: "/account/profile",
    meta: profilelwi6rEuniiMeta || {},
    component: () => import("/app/pages/account/profile.vue")
  },
  {
    name: "account-profile___en-GB",
    path: "/en-GB/account/profile",
    meta: profilelwi6rEuniiMeta || {},
    component: () => import("/app/pages/account/profile.vue")
  },
  {
    name: "account-recover-password___lt-LT",
    path: "/account/recover/password",
    component: () => import("/app/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___en-GB",
    path: "/en-GB/account/recover/password",
    component: () => import("/app/pages/account/recover/password.vue")
  },
  {
    name: "account-wishlist___lt-LT",
    path: "/account/wishlist",
    meta: wishlistzQE62vNi5oMeta || {},
    component: () => import("/app/pages/account/wishlist.vue")
  },
  {
    name: "account-wishlist___en-GB",
    path: "/en-GB/account/wishlist",
    meta: wishlistzQE62vNi5oMeta || {},
    component: () => import("/app/pages/account/wishlist.vue")
  },
  {
    name: "cart___lt-LT",
    path: "/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___en-GB",
    path: "/en-GB/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "checkout-id___lt-LT",
    path: "/checkout/:id()",
    meta: indexKZUQ8EqxmNMeta || {},
    component: () => import("/app/pages/checkout/[id]/index.vue")
  },
  {
    name: "checkout-id___en-GB",
    path: "/en-GB/checkout/:id()",
    meta: indexKZUQ8EqxmNMeta || {},
    component: () => import("/app/pages/checkout/[id]/index.vue")
  },
  {
    name: "checkout-id-paid___lt-LT",
    path: "/checkout/:id()/paid",
    meta: paidCexgTvKlRqMeta || {},
    component: () => import("/app/pages/checkout/[id]/paid.vue")
  },
  {
    name: "checkout-id-paid___en-GB",
    path: "/en-GB/checkout/:id()/paid",
    meta: paidCexgTvKlRqMeta || {},
    component: () => import("/app/pages/checkout/[id]/paid.vue")
  },
  {
    name: "checkout-id-unpaid___lt-LT",
    path: "/checkout/:id()/unpaid",
    meta: unpaid9xNbere4xkMeta || {},
    component: () => import("/app/pages/checkout/[id]/unpaid.vue")
  },
  {
    name: "checkout-id-unpaid___en-GB",
    path: "/en-GB/checkout/:id()/unpaid",
    meta: unpaid9xNbere4xkMeta || {},
    component: () => import("/app/pages/checkout/[id]/unpaid.vue")
  },
  {
    name: "checkout___lt-LT",
    path: "/checkout",
    meta: index7ZtduOIoVXMeta || {},
    component: () => import("/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___en-GB",
    path: "/en-GB/checkout",
    meta: index7ZtduOIoVXMeta || {},
    component: () => import("/app/pages/checkout/index.vue")
  },
  {
    name: "search___lt-LT",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___en-GB",
    path: "/en-GB/search",
    component: () => import("/app/pages/search.vue")
  }
]